import { matchPath } from "react-router-dom";
import type { ContextParams } from "./types";

/**
 * Matches `pattern` (e.g. "/projects/:id") as a prefix of `pathname`.
 * `reserved` lists values of the first param that belong to sibling routes
 * (e.g. "/equipment/tags" is a list page, not equipment "tags").
 */
export function matchContextPath(
  pattern: string,
  pathname: string,
  reserved: Record<string, string[]> = {},
): ContextParams | null {
  const match = matchPath({ path: pattern, end: false }, pathname);
  if (!match) return null;
  const params: ContextParams = {};
  for (const [name, value] of Object.entries(match.params)) {
    if (name === "*" || value === undefined) continue;
    if (reserved[name]?.includes(value)) return null;
    params[name] = value;
  }
  return params;
}
